/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable react/button-has-type */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, CardBody } from 'reactstrap';
import { config } from 'utils/config';
import { callApi, getDeviceUniqueID } from 'utils/utils';
import moment from 'moment';
import { Panel } from 'primereact/panel';
import FieldButton from 'components/Controls/FieldButton/FieldButton';
import SurveyManagementContestar from '../SurveyManagement/SurveyManagementContestar';
import InstructionsCard from 'components/Cards/InstructionsCard/InstructionsCard';
import swal from '@sweetalert/with-react';
import SweatAlertCustomIcon from '../../../../components/SweatAlert/SweatAlertCustomIcon';

const VisitLogRegister = (props) => {
  /* ################## useState area start ################## */
  const { t } = useTranslation(['visitLog', 'common']);
  const [Ubicacion, setUbicacion] = useState({});
  const [EsIniciarEncuesta, setEsIniciarEncuesta] = useState(false);
  const [IdEncuesta, setIdEncuesta] = useState(null);
  const [ClaUbicacion, setClaUbicacion] = useState(null);
  const [IdEncuestaContestada, setIdEncuestaContestada] = useState(null);
  const [DeviceUniqueID, setDeviceUniqueID] = useState(getDeviceUniqueID());
  const [VisitaRegistrada, setVisitaRegistrada] = useState(false);
  const [VisitaPendiente, setVisitaPendiente] = useState(null);
  const [SalidaRegistrada, setSalidaRegistrada] = useState(false);
  const refreshTimerClock = useRef();
  const [CurrentTime, setCurrentTime] = useState(new Date());
 
  useEffect(() => {    
    setClaUbicacion(props.ClaUbicacion === undefined ? 0 : props.ClaUbicacion);
    GetRegistroVisitanteEmcabezado(props.ClaUbicacion);
    GetRegistroVisitanteByDevice(props.ClaUbicacion);

    refreshTimerClock.current = setInterval(() => { 
      setCurrentTime(new Date());
    }, 1000);
    
    return () => {
      if (refreshTimerClock.current) {
        clearTimeout(refreshTimerClock.current);  
      }  
    }

  }, [props.ClaUbicacion, props.refresh]);

  const GetRegistroVisitanteEmcabezado = (pClaUbicacion) => {
    const urlWebService = `${config.UrlApiProject}VisitLog/GetRegistroVisitanteEmcabezado?ClaUbicacion=${pClaUbicacion}`;
    const paramsToService = {};
    callApi(urlWebService, 'GET', paramsToService, (response) => {
      console.log('ubi', response.data);
      setUbicacion(response.data.Ubicacion.length > 0 ? response.data.Ubicacion[0] : {});
    });
  };

  const GetRegistroVisitanteByDevice = (pClaUbicacion) => {
    const urlWebService = `${config.UrlApiProject}VisitLog/GetRegistroVisitanteByDevice`;
    const paramsToService = {
      ClaUbicacion: pClaUbicacion,
      FechaEntrada: null,
      FechaSalida: null,
      Accion: 0,
      DeviceUniqueID:getDeviceUniqueID()
    };
    callApi(urlWebService, 'POST', paramsToService, (response) => {
      const registroVisitanteList = response.data.RegistroVisitante || [];
      // Buscar si hay una visita pendiente (sin FechaSalida)
       if (registroVisitanteList.length>0) {
        setVisitaPendiente(registroVisitanteList[0]);
      } else {
        setVisitaPendiente(null);
        // Si no hay visita pendiente, abrir directamente la encuesta
        StartSurvey();
      }
    });
  };

  const onClickStarSurvey = () => {
    StartSurvey();
  };

  const StartSurvey = () => {
    const urlWebServiceSave = `${config.UrlApiProject}VisitLog/RegistroVisitante`;
    const paramsService = {
      ClaUbicacion:props.ClaUbicacion,
      IdEncuesta,
      DeviceUniqueID,
    };
    callApi(urlWebServiceSave, 'POST', paramsService, (response) => {
      const registroVisitante =
        response.data.RegistroVisitante.length > 0 ? response.data.RegistroVisitante[0] : {};
      setIdEncuestaContestada(registroVisitante.IdEncuestaContestada);
      setIdEncuesta(registroVisitante.IdEncuesta);
      setEsIniciarEncuesta(true);
    });
  };

  const closeModalEsIniciarEncuesta = () => {
    setEsIniciarEncuesta(false);
  };

  const onEncuestaTerminada = () => {
    setEsIniciarEncuesta(false);
    setVisitaRegistrada(true);
  };

  const onClickCheckedOut = () => {
    if (!VisitaPendiente) return;
    
    const urlWebServiceSave = `${config.UrlApiProject}VisitLog/RegistroVisitante`;
    const paramsService = {
      ClaUbicacion: VisitaPendiente.ClaUbicacion,
      IdEncuesta: VisitaPendiente.IdEncuesta,
      Accion: 3,
      IdRegistroVisitante: VisitaPendiente.IdRegistroVisitante,
      DeviceUniqueID
    };
    callApi(urlWebServiceSave, 'POST', paramsService, (response) => {
      setSalidaRegistrada(true);
      setVisitaPendiente(null);
    });
  };

  const performCheckOut = () => {
    // Obtener la información de la visita registrada para hacer el check out
    const urlWebService = `${config.UrlApiProject}VisitLog/GetRegistroVisitanteByDevice`;
    const paramsToService = {
      ClaUbicacion,
      FechaEntrada: null,
      FechaSalida: null,
      Accion: 0,
      DeviceUniqueID
    };
    callApi(urlWebService, 'POST', paramsToService, (response) => {
      const registroVisitanteList = response.data.RegistroVisitante || [];
      if (registroVisitanteList.length > 0) {
        const visitaRegistrada = registroVisitanteList[0];
        const urlWebServiceSave = `${config.UrlApiProject}VisitLog/RegistroVisitante`;
        const paramsService = {
          ClaUbicacion: visitaRegistrada.ClaUbicacion,
          IdEncuesta: visitaRegistrada.IdEncuesta,
          Accion: 3,
          IdRegistroVisitante: visitaRegistrada.IdRegistroVisitante,
          DeviceUniqueID
        };
        callApi(urlWebServiceSave, 'POST', paramsService, (response) => {
          setSalidaRegistrada(true);
          setVisitaRegistrada(false);
        });
      }
    });
  };

  const confirmationCheckOutMessageHTML = (
    <div>
      <SweatAlertCustomIcon
        title={t('visitLog:ConfirmCheckOut')}
        letter={t('common:QuestionMark')}
      >
      </SweatAlertCustomIcon>
      <div>{t('visitLog:ConfirmCheckOutMessage')}</div>
    </div>
  );

  const onConfirmCheckOut = () => {
    swal({
      buttons: {
        cancelar: {
          text: t('common:Cancel'),
          value: 'cancel',
          className: 'rounded-button danger',
        },
        continuar: {
          text: t('common:Continue'),
          value: 'continue',
          className: 'rounded-button light-green',
        },
      },
      content: confirmationCheckOutMessageHTML,
    }).then((value) => {
      switch (value) {
        case 'continue':
          performCheckOut();
          break;
        default:
          break;
      }
    });
  };

  return (
    <>
      {!VisitaRegistrada && !SalidaRegistrada ? (
        <>
          {VisitaPendiente && (
            <>
              <Row className="mb-4">
                <Col lg={12} md={12} sm={12} xs={12}>
                  <Card style={{ backgroundColor: '#fff3cd', border: '2px solid #ffc107', borderRadius: '8px' }}>
                    <CardBody style={{ padding: '2rem' }}>
                      <div className="text-center">
                        <i className="fas fa-exclamation-triangle" style={{ fontSize: '3rem', color: '#ffc107', marginBottom: '1rem' }}></i>
                        <h3 style={{ color: '#856404', marginBottom: '0.5rem', fontWeight: 'bold' }}>{t('visitLog:PendingCheckOut')}</h3>
                        <p style={{ fontSize: '1.1rem', color: '#856404', marginBottom: '0' }}>
                          {t('visitLog:PendingCheckOutMessage')}
                        </p>
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              </Row>
              <Row>
                <Col lg={12} md={12} sm={12} xs={12} className="text-center">
                  <FieldButton
                    label={t('visitLog:CheckOut')}
                    onClick={(e) => onClickCheckedOut()}
                    className="p-button-warning no-border"
                    style={{ 
                      fontSize: '1.5rem', 
                      padding: '1rem 3rem',
                      minWidth: '300px',
                      height: '60px',
                      fontWeight: 'bold'
                    }}
                    icon="fas fa-sign-out-alt"
                  />
                </Col>
              </Row>
            </>
          )}
          <Row>
            <Col>
              {EsIniciarEncuesta ? (
                <div>
                  <Card className="shadow-3 border-round-2xl p-4">
                    <div className="flex flex-column gap-2">
                      <h2 className="m-0 font-bold text-900">
                        {t('visitLog:Welcome')} {Ubicacion.NombreUbicacion}
                      </h2>

                      <span className="text-600 text-sm">
                        {moment(CurrentTime).format("MMMM Do YYYY, h:mm:ss a")}
                      </span>
                    </div>
                  </Card>
                  <div className='pt-3'>
                    <SurveyManagementContestar
                      IdEncuesta={IdEncuesta}
                      onClose={closeModalEsIniciarEncuesta}
                      onFinishSubmit={onEncuestaTerminada}
                      showAsModal={false}
                      isOpen={EsIniciarEncuesta}
                      IdEncuestaContestada={IdEncuestaContestada}
                    >
                    </SurveyManagementContestar>
                  </div>
                </div> 
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </>
      ) : VisitaRegistrada ? (
        <>
          <Row className="mb-4">
            <Col className="text-center">
              <InstructionsCard className="surveyNotFoundIntructions">
                <div className="text-center">
                  <i className="fas fa-check-circle" style={{ fontSize: '4rem', color: '#28a745', marginBottom: '1rem' }}></i>
                  <h2 style={{ color: '#28a745', marginBottom: '1rem' }}>{t('visitLog:VisitRegisteredSuccessfully')}</h2>
                  <p style={{ fontSize: '1.2rem', marginBottom: '1.5rem' }}>{t('visitLog:ThankYouForYourVisit')}</p>
                  <p style={{ fontSize: '1.1rem', color: '#6c757d', marginBottom: '2rem' }}>{t('visitLog:VisitUsSoon')}</p>
                </div>
              </InstructionsCard>
            </Col>
          </Row>
          <Row className="mt-4">
            <Col className="text-center">
              <p style={{ fontSize: '1.1rem', marginBottom: '1.5rem', color: '#6c757d' }}>
                <b>{t('visitLog:ReadyToCheckOut')}</b>
              </p>
              <FieldButton
                label={t('visitLog:CheckOut')}
                onClick={onConfirmCheckOut}
                className="p-button-success"
                style={{ 
                  fontSize: '1.1rem',
                  padding: '0.75rem 2rem',
                  fontWeight: 'bold',
                  borderRadius: '6px'
                }}
                icon="fas fa-sign-out-alt"
              />
            </Col>
          </Row>
          <Row>
            <Col>
              {EsIniciarEncuesta ? (
                <SurveyManagementContestar
                  IdEncuesta={IdEncuesta}
                  onClose={closeModalEsIniciarEncuesta}
                  onFinishSubmit={onEncuestaTerminada}
                  showAsModal={false}
                  isOpen={EsIniciarEncuesta}
                  IdEncuestaContestada={IdEncuestaContestada}
                >
                </SurveyManagementContestar>
              ) : (
                <></>
              )}
            </Col>
          </Row>
        </>
      ) : (
        <>
          <Row>
            <Col className="text-center">
              <InstructionsCard className="surveyNotFoundIntructions">
                <div className="text-center">
                  <i className="fas fa-check-circle" style={{ fontSize: '4rem', color: '#28a745', marginBottom: '1rem' }}></i>
                  <h2 style={{ color: '#28a745', marginBottom: '1rem' }}>{t('visitLog:CheckOutRegisteredSuccessfully')}</h2>
                  <p style={{ fontSize: '1.2rem' }}>{t('visitLog:ThankYouForYourVisit')}</p>
                </div>
              </InstructionsCard>
            </Col>
          </Row> 
        </>
      )}
    </>
  );
};
export default VisitLogRegister;

